import React from "react";
import { Flex, Button } from "@chakra-ui/react";

interface FooterButtonProps {
  primaryBtnTxt?: string; // view transactions
  secondaryBtnTxt?: string; // close or cancel
  onSubmitPrimary?: () => void;
  onSubmitSecondary?: () => void;
}

const FooterButtons = ({
  primaryBtnTxt,
  secondaryBtnTxt,
  onSubmitPrimary,
  onSubmitSecondary,
}: FooterButtonProps) => {
  return (
    <Flex
      flexDirection={{
        base: "column-reverse",
        md: "row",
      }}
      alignItems="center"
      justifyContent="center"
    >
      {secondaryBtnTxt && onSubmitSecondary && (
        <Button
          variant="unstyled"
          p={{ base: "10px 32px", md: "12px 45px" }}
          bg="backgroundCard"
          color="textPrimary"
          border="1px"
          borderColor="seperator"
          onClick={onSubmitSecondary}
          mr={{
            base: "0rem",
            md: "1rem",
          }}
          mt={{
            base: "0.75rem",
            md: "0rem",
          }}
          borderRadius="0.5rem"
          lineHeight="0"
          fontSize={{ base: "14px", md: "16px" }}
          minW={{ base: "200px", md: "fit-content" }}
          h={{ base: "40px", md: "48px" }}
        >
          {secondaryBtnTxt}
        </Button>
      )}
      {primaryBtnTxt && onSubmitPrimary && (
        <Button
          variant="unstyled"
          p={{ base: "10px 32px", md: "12px 45px" }}
          bg="textPrimary"
          color="white"
          borderRadius="0.5rem"
          onClick={onSubmitPrimary}
          fontSize={{ base: "14px", md: "16px" }}
          h={{ base: "40px", md: "48px" }}
          minW={{ base: "200px", md: "fit-content" }}
        >
          {primaryBtnTxt}
        </Button>
      )}
    </Flex>
  );
};

export default FooterButtons;
